import React, { FC, useContext, useState } from 'react';
import { SecurityQuestion } from '../../../Models/SecurityQuestion';
import FormRow from '../../FormRow';
import esSeqQuest from '../../../Localization/LanguageFiles/esSeqQuest.json';
import LocalizationContext from '../../../Localization/LanguageContext';
import { ILanguage } from '../../../Models/LocInfo';
import { ILocalizationContext } from '../../../Localization/Models/ILocalizationContext';

interface Props {
  id: string;
  label: string;
  allQuestions: SecurityQuestion[] | null;
  question: SecurityQuestion;
  setQuestion: React.Dispatch<React.SetStateAction<SecurityQuestion>>;
  ignoreQuestion1: SecurityQuestion;
  ignoreQuestion2: SecurityQuestion;
  required: boolean;
  setRequired: React.Dispatch<React.SetStateAction<boolean>>;
}

const Question: FC<Props> = ({
  id,
  label,
  allQuestions,
  question,
  setQuestion,
  ignoreQuestion1,
  ignoreQuestion2,
  required,
  setRequired,
}) => {
  const [esQuestions] = useState<any>(esSeqQuest);
  const { locale } = useContext(LocalizationContext) as ILanguage;
  const { getValue } = useContext(LocalizationContext) as ILocalizationContext;

  const selectQuestion = (
    questionID: string,
    setter: React.Dispatch<React.SetStateAction<SecurityQuestion>>
  ) => {
    if (allQuestions) {
      for (let i = 0; i < allQuestions?.length; i++) {
        if (questionID === allQuestions[i].id) {
          setter({
            id: allQuestions[i].id,
            questionText: allQuestions[i].questionText,
          });
          setRequired(false);
        }
      }
    }
  };

  return (
    <FormRow>
      <label className='form-label mb-1 px-0 text-graphite'>{label}</label>
      <select
        id={id}
        value={question.id}
        className={`form-select form-select-group text-input ${
          required && question.questionText === '' && 'question-required'
        }`}
        onChange={(e) => selectQuestion(e.target.value, setQuestion)}
        onFocus={() => setRequired(false)}
        onBlur={(e) => {
          selectQuestion(e.target.value, setQuestion);
          question.questionText === '' && setRequired(true);
        }}
      >
        <option
          disabled={true}
          hidden
          value=''
          className={`${required && 'text-bluebird'}`}
        >
          {getValue('SecurityQuestions', 'QuestionsLabel')}
        </option>
        {allQuestions?.map(
          (item, i) =>
            item.id !== ignoreQuestion1.id &&
            item.id !== ignoreQuestion2.id && (
              <option key={item.id} value={item.id}>
                {locale === 'es' && esQuestions['SpanishQuestions'][item.id]
                  ? esQuestions['SpanishQuestions'][item.id]
                  : item.questionText}
              </option>
            )
        )}
      </select>
    </FormRow>
  );
};

export default Question;
